import { registerBrick } from 'olympe';
import {ReactBrick, useProperty} from "@olympeio/core";
import {combineLatest} from "rxjs";
import React, {useEffect, useState} from "react";
import { Visualizer } from "react-sound-visualizer";


export default class SoundVisualizer extends ReactBrick {
    /**
     * @override
     */
    setupExecution($) {
        return combineLatest([
            $.observe('Hidden', false),
        ]);
    }
    /**
     * @override
     */
    static getReactComponent($) {



        return (props) => {
            const [hidden] = props.values;

            const mode = useProperty($, 'mode');
            const custom = useProperty($, 'custom');
            const isRecording = useProperty($, 'is recording');
            const barColor = useProperty($, 'bar color');
            const lineWidth = useProperty($, 'line width');
            const [audio, setAudio] = useState(null);
            const [customParam, setCustomParam] = useState(100);

            useEffect(() => {
                if(isRecording) {
                    navigator.mediaDevices
                        .getUserMedia({
                            audio: true,
                            video: false,
                        })
                        .then(setAudio);
                } else {
                    audio?.getTracks().forEach((track) => track.stop());
                }
            }, [isRecording])

            useEffect(() => {
                if(mode === 'continuous') {
                    setCustomParam(Math.max(1, custom));
                } else {
                    setCustomParam(Math.min(1, custom));
                }
            }, [custom, mode])


            return !hidden && (
                <div style={{ height: '100%', width: '100%' }}>
                    <Visualizer audio={audio} autoStart={true} strokeColor={barColor?.toHexString()} mode={mode} rectWidth={lineWidth} slices={customParam} heightNorm={customParam}>
                        {
                            ({ canvasRef, stop, start, reset }) => {
                                return (
                                    <canvas ref={canvasRef} style={{height: '100%', width: '100%'}}/>
                                )
                            }
                        }
                    </Visualizer>
                </div>
            );
        }
    }
}

registerBrick('0190e52170a162e5ac5c', SoundVisualizer);
